var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgHome = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, /*#__PURE__*/React.createElement("mask", {
  id: "mask0_4166_22789",
  style: {
    maskType: "luminance"
  },
  maskUnits: "userSpaceOnUse",
  x: 0,
  y: 0,
  width: 24,
  height: 24
}, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M24 0H0V24H24V0Z",
  fill: "white"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask0_4166_22789)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M13.79 2.31958C13.68 2.21648 13.5601 2.13458 13.4301 2.07878C13.2901 2.02288 13.15 1.99408 13 1.99408C12.86 1.99408 12.72 2.02288 12.58 2.07878C12.45 2.13458 12.33 2.21648 12.22 2.31958L2.31995 12.2212C2.21995 12.3235 2.13996 12.4452 2.07996 12.5792C2.01996 12.7133 2 12.8571 2 13.0023C2 13.1476 2.01996 13.2914 2.07996 13.4254C2.13996 13.5595 2.21995 13.6812 2.31995 13.7835C2.41995 13.8854 2.55005 13.9661 2.68005 14.0208C2.81005 14.0756 2.95998 14.1033 3.09998 14.1025H4.19995V21.8038C4.19995 22.3874 4.42998 22.947 4.84998 23.3597C5.25998 23.7723 5.82002 24.0041 6.40002 24.0041H19.61C20.19 24.0041 20.75 23.7723 21.16 23.3597C21.57 22.947 21.8101 22.3874 21.8101 21.8038V14.1025H22.91C23.2 14.1025 23.4801 13.9866 23.6801 13.7803C23.8901 13.574 24.01 13.2941 24.01 13.0023C24.01 12.8575 23.98 12.714 23.92 12.58C23.87 12.4459 23.7899 12.324 23.6899 12.2212L13.79 2.31958ZM6.40002 21.8038V11.253L13 4.65198L19.61 11.253V21.8038H6.40002Z",
  fill: "currentColor"
}))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgHome);
export { ForwardRef as ReactComponent };